import React from "react";
import { Box, BoxStyleProps } from "@twilio-paste/core";

import { Field as FieldDefinition } from "../../store/definitions";
import { TextField } from "./TextField";
import { TextArea } from "./TextArea";
import { EmailField } from "./EmailField";
import { PhoneField } from "./PhoneField";
import { CheckBox } from "./Checkbox";
import { DropDown } from "./DropDown";

type FieldProps = {
    field: FieldDefinition;
    onChange?: (newValue: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLElement>) => void;
    value?: string;
    boxStyle?: BoxStyleProps;
};

export const Field = (props: FieldProps) => {
    const { field, boxStyle, ...otherProps } = props;

    const renderField = React.useCallback(() => {
        switch (field.type) {
            case "dropdown":
                return <DropDown field={field} {...otherProps} />;
            case "checkbox":
                return <CheckBox field={field} {...otherProps} />;
            case "email":
                return <EmailField field={field} {...otherProps} />;
            case "phone":
                return <PhoneField field={field} {...otherProps} />;
            case "textArea":
                return <TextArea field={field} {...otherProps} />;

            case "text":
            default:
                return <TextField field={field} {...otherProps} />;
        }
    }, [field, otherProps]);

    return <Box {...boxStyle}>{renderField()}</Box>;
};
